import { r } from 'config/routes'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { createPanelRoute } from 'views/panel/PanelLayout'

const ReportList = lazy(() => import('../List'))
const ReportEdit = lazy(() => import('../Edit'))
const ReportSingle = lazy(() => import('../Single'))

export const reportsRoutes: RouteObject[] = [
  createPanelRoute({
    path: r['report.list'],
    element: <ReportList />,
  }),
  createPanelRoute({
    path: r['report.add'],
    element: <ReportEdit />,
  }),
  createPanelRoute({
    path: r['report.edit'](),
    element: <ReportEdit />,
  }),
  createPanelRoute({
    path: r['report.view'](),
    element: <ReportSingle />,
  }),
]
